import { Terminal } from 'lucide-react';
import { ActivityEmptyState } from '../components/shared/ActivityEmptyState';

const LogsPage = () => {
  return (
    <div className="max-w-3xl mx-auto py-12 px-6 animate-fade-in">
      <ActivityEmptyState
        icon={Terminal}
        title="Live Agent Logs"
        description="Real-time log streaming from agent worktrees. Connect the log service to start viewing output."
        status="not-connected"
      />
    </div>
  );
};

export default LogsPage;
